<template>
  <div id="app">
    <modal></modal>
    <contact></contact>
    <panel></panel>
    <maps></maps>
    <place-info></place-info>
    <proximity></proximity>
    <range></range>
    <route></route>
  </div>
</template>

<script>
  /* global dataLayer */
  /* eslint no-undef: "error" */

  import store from './store/store'
  import Maps from './components/Maps'
  import Modal from './components/Modal'
  import Panel from './components/Panel'
  import PlaceInfo from './components/PlaceInfo'
  import Proximity from './components/Proximity'
  import Range from './components/Range'
  import Route from './components/Route'
  import Contact from './components/Contact'

  export default {
    name: 'app',
    data () {
      return {
        breakpoint: '1024px',
        panel: '',
        maps: '',
        isEmbed: store.state.isEmbed
      }
    },
    components: {
      Maps, Panel, Modal, PlaceInfo, Proximity, Range, Route, Contact
    },
    mounted () {
      for (var i = 0; i < this.$children.length; i++) {
        if (this.$children[i].$options._componentTag === 'panel') {
          this.panel = this.$children[i]
        }
      }
      var mq = window.matchMedia(`(max-width: ${this.breakpoint})`)
      mq.addListener(this.checkisMobile)
      this.checkisMobile(mq)
      dataLayer.push({rendu: 'Plan'})
    },
    methods: {
      checkisMobile: function (mq) {
        if (mq.matches) {
          this.panel._data.panel = false
          store.state.isMobile = true
        } else {
          this.panel._data.panel = true
          store.state.isMobile = false
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// App.vue?afd8ebe4